import CountUp from "react-countup";
import NyindlagtePlotMini from "./NyindlagtePlotMini";

const easeDuration = 2; // seconds

function Nyindlagte({ nyindlagte }) {
	const nyindlagteSenest = nyindlagte.sort((a, b) => b.date - a.date)[0]

	return (
		<div>
			<h1>Nyindlagte</h1>
			<div className="numberCircle" style={{ backgroundColor: "steelblue", transition: `background-color ${easeDuration}s ease-out` }}>
				<CountUp end={nyindlagteSenest.newHospitalized} decimals={0} duration={easeDuration} />
				<div className="circleDate">
					<small>{nyindlagteSenest.date.toISOString().substring(0, 10)}</small>
				</div>
			</div>
			<NyindlagtePlotMini nyindlagte={nyindlagte} />
		</div>
	)
}

export default Nyindlagte